import React from "react";
import { Stack, Typography, styled, Box, Rating } from "@mui/material";

const Card = styled(Stack)(({ theme }: any) => ({
  justifyContent: "space-evenly",
  width: "100%",
  height: "100%",
  border: `1px solid ${theme.palette.common.borderGrey}`,
  alignItems: "flex-start",
  padding: 24,
}));

interface IndustryEventCardInterface {
  image: string;
  name: string;
  location: string;
  date: string;
  description: string;
}
const StyledRating = styled(Rating)({
  "& .MuiRating-iconFilled": {
    color: "rgba(210, 56, 56, 1)",
  },
});
const IndustryEventCard = ({
  image,
  name,
  location,
  date,
  description,
}: IndustryEventCardInterface) => {
  const [value, setValue] = React.useState<number | null>(2);
  return (
    <Card>
      <Stack alignSelf="center" mb={1}>
        <img src={image} width="255px" height="162px" alt="" />
      </Stack>
      <Stack spacing={1}>
        <Typography color="primary" variant="h5">
          {name}
        </Typography>
        <Typography variant="h6" className="font-grey" fontWeight={500}>
          {location}
        </Typography>
        <Typography
          variant="h6"
          fontWeight={500}
          color="rgb(28 18 18)"
          fontStyle="italic"
        >
          {description}
        </Typography>
        <Stack direction="row" alignItems="center">
          <Box>
            <StyledRating
              value={value}
              onChange={(_, newValue) => {
                setValue(newValue);
              }}
            />
          </Box>
          <Box
            width="5px"
            height="5px"
            borderRadius={2.5}
            className="background-black"
            ml={2}
            mr={2}
          />
          <Typography variant="h6" fontWeight={500}>
            {date}{" "}
          </Typography>
        </Stack>
      </Stack>
    </Card>
  );
};
export default IndustryEventCard;
